var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 57 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_153_18537)" } }, [
        _c("path", {
          attrs: {
            d:
              "M9.93079 14.7639L44.4914 14.6601L38.8546 55.6802L15.8141 55.7495L9.93079 14.7639Z",
            fill: "#E5E5E5"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M2.43239 53.277L2.98851 48.9321L0.111064 45.674L4.37836 46.2403L7.57827 43.3105L7.02215 47.6554L9.8996 50.9135L5.6323 50.3473L2.43239 53.277Z",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            width: "3.18908",
            height: "3.19268",
            transform:
              "matrix(-0.992542 0.121901 0.139729 0.99019 54.121 17.5164)",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            width: "3.18908",
            height: "3.19268",
            transform:
              "matrix(-0.992542 0.121901 0.139729 0.99019 55.287 11.7659)",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("circle", {
          attrs: {
            cx: "27.3198",
            cy: "29.3337",
            r: "8.6402",
            transform: "rotate(-0.172182 27.3198 29.3337)",
            fill: "#179E7E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M7.04956 14.7764L47.3703 14.6552L44.473 8.90374L9.91231 9.0076L7.04956 14.7764Z",
            fill: "#8E8E8E"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M9.97742 9.22412L44.5381 9.12026L44.517 2.1034L9.95633 2.20726L9.97742 9.22412Z",
            fill: "#8E8E8E"
          }
        }),
        _vm._v(" "),
        _c("line", {
          attrs: {
            x1: "44.2268",
            y1: "7.2604",
            x2: "32.1754",
            y2: "7.2604",
            stroke: "black",
            "stroke-width": "1.054"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_153_18537" } }, [
          _c("rect", {
            attrs: {
              width: "56",
              height: "56",
              fill: "white",
              transform: "translate(0.289368)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }